import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { scrollToElement } from 'core/utils/helpers/scrollToElement';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useDropdown } from 'core/hooks/useDropdown';
import { useToggleMore } from 'core/hooks/useToggleMore';

import { triggerPsrApplyFilterGaEvent } from 'core/modules/ProductSearchResults/actions';

function FilterMobile({ title, facet, filterHook }) {
  const dispatch = useDispatch();
  const filterRef = useRef();
  const { toggleSubnav, isFocused } = useDropdown(filterRef);
  const { toggleIdInFilter, checkIsIdAddedToFilter } = filterHook;
  const { itemsToShow, renderShowMoreButton } = useToggleMore({ items: facet.values, limit: 9 });

  const onCheckboxChange = (facetName, id) => {
    scrollToElement(document.body, 0);
    toggleIdInFilter(facetName, id);

    const isAddedToFilter = !checkIsIdAddedToFilter(facetName, id);
    dispatch(triggerPsrApplyFilterGaEvent(facetName, isAddedToFilter));
  };

  return (
    <div ref={filterRef} className="mn_filter mn_psrMobileFilter">
      <button className="mn_filterTitle" onClick={toggleSubnav} aria-expanded={isFocused}>
        {title || facet.label}
      </button>
      { isFocused &&
        <div className="mn_filterDropdown">
          <ul>
            {itemsToShow.map(({ id, label }) => (
              <li key={id}>
                <label>
                  <input
                    type="checkbox"
                    onChange={() => onCheckboxChange(facet.name, id)}
                    checked={checkIsIdAddedToFilter(facet.name, id)}
                  />
                  <span className="mn_name">{label}</span>
                </label>
              </li>
            ))}
          </ul>
          {renderShowMoreButton()}
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FilterMobile {...props} /></ComponentErrorBoundary>;
